import { Link } from 'react-router-dom';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';

interface FooterProps {
    showHomeButton?: boolean;
}

const Footer = ({ showHomeButton = true }: FooterProps) => {
    return (
        <footer className="footer">
            {showHomeButton && (
                <div className="footer__home">
                    <Link to="/" className="footer__home-btn" aria-label="Home">
                        <HomeOutlinedIcon fontSize="large" aria-hidden="true" />
                    </Link>
                    <span className="footer__home-label">home</span>
                </div>
            )}

            <div className="footer__links">
                <p>
                    {'\u00A9'} Accent Housing Limited {new Date().getFullYear()} &nbsp; | &nbsp;
                    <a href="https://www.accentgroup.org/about-us/policies-and-corporate-documents/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                </p>
            </div>
        </footer>
    );
};

export default Footer;
